import type { Identidade, StatusBot, TipoBot } from './types';

/**
 * O rótulo de migração responde "quem ainda usa o token compartilhado?".
 *
 * Não é decoração: enquanto houver bot em `legado` ou `migrando`, o
 * `PROJECT_API_TOKEN` não pode ser desligado — e quem tiver esse token consegue
 * gravar log em nome desses bots.
 */
export const IDENTIDADE_META: Record<
  Identidade,
  { label: string; cor: string; explicacao: string }
> = {
  legado: {
    label: 'Token compartilhado',
    cor: 'red',
    explicacao:
      'Escreve com o token único. Qualquer processo que tenha esse token pode gravar log em nome dele.',
  },
  migrando: {
    label: 'Migrando',
    cor: 'orange',
    explicacao:
      'Já tem credencial própria, mas ainda apareceu usando o token compartilhado. Normal durante a virada.',
  },
  propria: {
    label: 'Credencial própria',
    cor: 'green',
    explicacao: 'Só usa a credencial dele. Migrado.',
  },
  provisionado: {
    label: 'Credencial não usada',
    cor: 'blue',
    explicacao: 'Tem token, mas ainda não escreveu nada com ele.',
  },
  sem_credencial: {
    label: 'Sem credencial',
    cor: 'gray',
    explicacao: 'Não tem token e não apareceu escrevendo.',
  },
};

/**
 * O status não é decoração: ele conta ao operador em que passo do provisionamento
 * o bot parou, e o que fazer a seguir. Por isso cada um carrega uma ação.
 */
export const STATUS_META: Record<
  StatusBot,
  { label: string; cor: string; explicacao: string; proximoPasso: string | null }
> = {
  nao_provisionado: {
    label: 'Sem credencial',
    cor: 'gray',
    explicacao: 'Cadastrado, mas ainda não fala com a API.',
    proximoPasso: 'Gerar token',
  },
  aguardando_handshake: {
    label: 'Aguardando 1ª conexão',
    cor: 'orange',
    explicacao: 'Token gerado — o bot ainda não subiu com ele.',
    proximoPasso: 'Colocar o token no .env do bot e reiniciar',
  },
  ativo: {
    label: 'Ativo',
    cor: 'green',
    explicacao: 'Já se apresentou e declarou o que sabe fazer.',
    proximoPasso: null,
  },
  inativo: {
    label: 'Inativo',
    cor: 'red',
    explicacao: 'Desligado manualmente.',
    proximoPasso: null,
  },
};

export const TIPO_META: Record<TipoBot, { label: string; cor: string }> = {
  ETL: { label: 'ETL', cor: 'blue' },
  RPA: { label: 'RPA', cor: 'orange' },
  WEBSCRAP: { label: 'WebScrap', cor: 'purple' },
};

export const TIPOS_BOT: TipoBot[] = ['ETL', 'RPA', 'WEBSCRAP'];

export const AREAS_SUGERIDAS = [
  'Fiscal',
  'Contábil',
  'Departamento Pessoal',
  'Societário',
  'Financeiro',
  'Infraestrutura',
];
